export default class BBDO_Share {
	static initClass() {
		this.prototype.$el = null;
	}

	constructor($el) {
		this.$el = $el;
		this.init_events();
	}

	init_events() {
		return this.$el.on('click', e => {
			e.preventDefault();

			if (this.$el.hasClass('facebook')) {
				const facebook_url = `http://www.facebook.com/sharer/sharer.php?u=${window.site.current_url}`;
				return this.open_popup(facebook_url, 'Facebook');
			} else if (this.$el.hasClass('twitter')) {
				const url = window.site.twitter_url;
				const text = window.site.twitter_copy;
				//hastag = encodeURIComponent("leeflekker")
				//twitter_url = "https://twitter.com/share?url="+url+"&hashtags="+hastag+"&text=" + text
				const twitter_url = `https://twitter.com/share?url=${url}&text=${text}`;
				return this.open_popup(twitter_url, 'Twitter');
			} else if (this.$el.hasClass('pinterest')) {
				return PinUtils.pinOne({
					'url': window.site.current_url,
					'media': $('.header__image__wrapper > .header__image:first-child').attr('src'),
					'description': $('meta[property="og:description"]').attr('content')
				});
			}
		});
	}

	open_popup(url, title) {
		const width = 575;
		const height = 400;
		const left = ($(window).width() - width) / 2;
		const top = ($(window).height() - height) / 2;

		const opts = 'status=1' +
			',width=' + width +
			',height=' + height +
			',top=' + top +
			',left=' + left;

		return window.open(url, title, opts);
	}
}